var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoveAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.111 20.3755C14.6039 21.1578 11.9057 21.2051 9.37549 20.5174C9.45629 20.2873 9.5 20.0414 9.5 19.7859V15.105C9.5 14.8723 9.46373 14.6475 9.39619 14.4354C11.2132 13.9677 13.1183 13.8752 14.9795 14.1656L15.549 14.2545C16.317 14.3743 16.8929 14.8806 17.1179 15.5092L14.7437 16.3175C14.3544 16.45 14.1536 16.8529 14.2952 17.2173C14.4367 17.5818 14.867 17.7698 15.2563 17.6372L17.6228 16.8316L19.9824 16.2793C21.0073 16.0395 22 16.7651 22 17.7541C22 18.4084 21.5528 18.9893 20.8897 19.1962L17.111 20.3755Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.1688C2.44772 14.1688 2 14.5879 2 15.105V19.7859C2 20.303 2.44772 20.7221 3 20.7221H7C7.55228 20.7221 8 20.303 8 19.7859V15.105C8 14.5879 7.55228 14.1688 7 14.1688H3Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4809 11.1893C13.0097 9.99549 11 8.02338 11 6.15875C11 3.04374 13.7501 1.88075 16 4.28706C18.2499 1.88075 21 3.04374 21 6.15873C21 8.02341 18.9903 9.99551 17.5191 11.1893C16.8531 11.7298 16.5201 12 16 12C15.4799 12 15.1469 11.7298 14.4809 11.1893Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveAlt);
export default __webpack_public_path__ + "static/media/love-alt.65569c522fb7fa1c570dcd150ae94c6e.svg";
export { ForwardRef as ReactComponent };